import { useTranslation } from "react-i18next";
import { Link } from "react-scroll";
import { envChangeType } from "../../../../../../plugins/utils";
import styles from "./styleModule";

const CategoryItem = ({
  category,
  active = false,
  onClick = () => {},
  selectedCategory,
  categoryItemContainerStyle = "",
  categoryItemContainerActiveStyle = "",
  categoryItemImageStyle = "",
  categoryTitleStyle = "",
  categoryTitleActiveStyle = "",
  continuousScroll = false,
  containerId = "gameContainer",
}) => {
  const { t } = useTranslation();
  const renderContent = () => {
    if (continuousScroll) {
      return (
        <Link
          to={category?.game_category_code}
          offset={-56}
          containerId={containerId}
          spy={selectedCategory !== "hot"}
          duration={250}
          smooth={true}
          className={`${styles.categoryContainer} ${categoryItemContainerStyle} ${
            active ? styles.active : ""
          } ${active ? categoryItemContainerActiveStyle : ""}`}
          onClick={() => {
            onClick(category?.game_category_code);
          }}
          onSetActive={() => {
            onClick(category?.game_category_code);
          }}
        >
          <img
            className={`${styles.image} ${categoryItemImageStyle}`}
            src={
              active
                ? `/images/logo/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/${category?.game_category_code}_active.png`
                : `/images/logo/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/${category?.game_category_code}.png`
            }
            alt={category?.game_category_code}
          />
          <div
            className={`${styles.title} ${categoryTitleStyle} ${active ? styles.active : ""} ${
              active ? categoryTitleActiveStyle : ""
            }`}
          >
            {t([
              `home.games.${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}.${category?.game_category_code}`,
              `home.games.${category?.game_category_code}`,
            ])}
          </div>
        </Link>
      );
    }
    return (
      <div
        className={`${styles.categoryContainer} ${categoryItemContainerStyle} ${
          active ? styles.active : ""
        } ${active ? categoryItemContainerActiveStyle : ""}`}
        onClick={() => {
          onClick(category?.game_category_code);
        }}
      >
        <img
          className={`${styles.image} ${categoryItemImageStyle}`}
          src={
            active
              ? `/images/logo/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/${category?.game_category_code}_active.png`
              : `/images/logo/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/${category?.game_category_code}.png`
          }
          alt={category?.game_category_code}
        />
        <div
          className={`${styles.title} ${categoryTitleStyle} ${active ? styles.active : ""} ${
            active ? categoryTitleActiveStyle : ""
          }`}
        >
          {t([
            `home.games.${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}.${category?.game_category_code}`,
            `home.games.${category?.game_category_code}`,
          ])}
        </div>
      </div>
    );
  };
  return renderContent();
};
export default CategoryItem;
